import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DropDownSelect from '../../../../../components/DropDownSelect';
import {useGetAllTeachersAccessibleSchoolsMutation} from '../../../../../features/authentication/schoolApiSlice';
import {useGetTeachersBySchoolIdMutation} from '../../../../../features/authentication/studentApiSlice';
import {useGetTeacherClassesMutation, useGetClassStudentsMutation, useDuplicateClassMutation} from '../../../../../features/authentication/classesApiSlice';
import { Col, Container, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus, faPlus } from '@fortawesome/pro-solid-svg-icons';
import CustomToast from '../../../../../components/Toast';
import Skeleton from 'react-loading-skeleton';

const DuplicateClass = ({onCancel, handleSave}) =>
{
  const [getAllSchools] = useGetAllTeachersAccessibleSchoolsMutation();
  const [getTeachersBySchoolId] = useGetTeachersBySchoolIdMutation();
  const [getTeacherClasses] = useGetTeacherClassesMutation();
  const [getClassStudents] = useGetClassStudentsMutation();
  const [duplicateClassAPI] = useDuplicateClassMutation();
  const [schools, setSchools] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [classes, setClasses] = useState([]);
  const [selectedSchoolId, setSelectedSchoolId] = useState(0);
  const [selectedSchoolName, setSelectedSchoolName] = useState('');
  const [selectedTeacherId, setSelectedTeacherId] = useState(0);
  const [selectedTeacherName, setSelectedTeacherName] = useState('');
  const [selectedClassId, setSelectedClassId] = useState(0);
  const [selectedClassName, setSelectedClassName] = useState('');
  const [displayStudents, setDisplayStudents] = useState(false);
  const [students, setStudents] = useState(null);
  const [classStudentsLoaded, setClassStudentLoaded] = useState(false);
  const [apiCallInProcess, setApiCallInProcess] = useState(false);

  useEffect(()=>{
    getAllSchoolsAsync();
  },[]);

  async function getAllSchoolsAsync()
  {
    var response = await getAllSchools().unwrap();
    setSchools(response);
    if(response.length>0)
    {
      var selectedSchoolId = response.filter(x=>x.selected == true).length>0 ? response.filter(x=>x.selected == true)[0]: response[0];
      await getAllTeachersAsync(selectedSchoolId.id);
      setSelectedSchoolId(selectedSchoolId.id);
      setSelectedSchoolName(selectedSchoolId.name);
    }
  }
  async function getAllTeachersAsync(schoolId)
  {
    setTeachers([]);
    setClasses([]);
    setSelectedTeacherId(null);
    setSelectedTeacherName('');
    ResetStudentViewStates();
    var response = await getTeachersBySchoolId(schoolId).unwrap();
    setTeachers(response);
    if(response.length>0)
    {
      await getAllClassesAsync(schoolId,response[0].id);
      setSelectedTeacherId(response[0].id);
      setSelectedTeacherName(response[0].name);
    }
  }
  async function getAllClassesAsync(schoolId,teacherId)
  {
    setClasses([]);
    setSelectedClassId(null);
    setSelectedClassName('');
    const options={
      schoolId:schoolId,
      teacherId:teacherId
    };
    var response = await getTeacherClasses(options).unwrap();
    setClasses(response);
    if(response.length>0)
    {
      setSelectedClassId(response[0].id);
      setSelectedClassName(response[0].name);
    }
  }

  const handleSchoolChange = async (id)=>
  {
    setSelectedSchoolId(parseInt(id));
    await getAllTeachersAsync(parseInt(id));
  };

  const handleTeacherChange=async(id)=>
  {
    setSelectedTeacherId(parseInt(id));
    ResetStudentViewStates();
    await getAllClassesAsync(selectedSchoolId, parseInt(id));
  };
       
  const handleClassChange=(id)=>
  {
    setSelectedClassId(parseInt(id));
    ResetStudentViewStates();
  };

  function ResetStudentViewStates()
  {
    setDisplayStudents(false);
    setStudents(null);
    setClassStudentLoaded(false);
  }

  const handleDisplayStudent=async()=>
  {
    if(!(selectedClassId>0 && selectedTeacherId >0 && selectedSchoolId >0))
    {
      return;
    }
    const options={
      id:selectedClassId,
      schoolId:selectedSchoolId
    };
    setDisplayStudents(!displayStudents);
    if(!displayStudents && !classStudentsLoaded)
    {
      var result = await getClassStudents(options).unwrap();
      setStudents(result);
      setClassStudentLoaded(true);
    }
  };

  const handleSaveOnClick= async()=>
  {
    if(!selectedClassId)
    {
      return;
    }
    setApiCallInProcess(true);
    var response = await duplicateClassAPI(selectedClassId);
    if (response?.error) {
      CustomToast(response.error.data.error, 'error');
    }else
    {
      CustomToast(response.data.message, 'success');
    }
    handleSave();
    setApiCallInProcess(false);
  };

  return (<>
    <Container>
      <Row>
        <Col>
          <div className="col-12 d-flex align-items-start mb-4">
            <span className="flex-shrink-0">
              <i className="fa-duotone fa-circle-info fs-1 mr-2 clr-fa-circle-question"></i>
            </span>
            <p>
                Select the school, then a teacher, then selected class you want to duplicate. When selected, click OK to duplicate the class. The duplicated class will have the same name as original class.   
            </p>
          </div>
        </Col>
      </Row>
      <Row className='mb-4'>
        <Col>  
          <label className='form-label'>Select School</label>      
          <DropDownSelect
            value={schools}
            selectedId={selectedSchoolId}
            setSelectedId={(id)=>handleSchoolChange(id)}
            dropdownId="schoolSelect"
            selectedName={selectedSchoolName}
            setSelectedName={setSelectedSchoolName}
          />
        </Col>
        <Col>
          <label className='form-label'>Select Teacher</label>      
          <DropDownSelect
            value={teachers}
            selectedId={selectedTeacherId}
            setSelectedId={(id)=>handleTeacherChange(id)}
            dropdownId="teacherSelect"
            selectedName={selectedTeacherName}
            setSelectedName={setSelectedTeacherName}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <label className='form-label'>Select Class</label>      
          <DropDownSelect
            value={classes}
            selectedId={selectedClassId}
            setSelectedId={(id)=>handleClassChange(id)}
            dropdownId="classSelect"
            selectedName={selectedClassName}
            setSelectedName={setSelectedClassName}
          />
        </Col>
        <Col className='d-grid'>
          <div className="align-items-end justify-content-end d-flex align-item-center report-button">
            <div className='d-flex cursor-pointer' onClick={() => handleDisplayStudent()}>Display students in selected class &nbsp;
              {
                <div
                  className='ml-1'>
                  {displayStudents ? (
                    <FontAwesomeIcon icon={faMinus} />
                  ) : (
                    <FontAwesomeIcon icon={faPlus} />
                  )}
                </div>
              }
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          {displayStudents && <Container className='mt-5'>
            <div className="border-grey">
              <Row>
                {students?.map((student) => (
                  <Col key={student.studentId} md={3} className='pb-4'>
                    <div className="student-card">
                      {student.lName}&nbsp;{student.fName}
                    </div>
                  </Col>
                ))}
                {students != null && students.length ==0 && <Col className='text-danger'>No Students Found</Col>}
                {students == null && <>  
                  <Col key="1" md={3}><Skeleton/></Col>
                  <Col key="2" md={3}><Skeleton/></Col>
                  <Col key="3" md={3}><Skeleton/></Col>
                </>}
              </Row>
            </div>
          </Container>
          }        
        </Col>
      </Row>
      <Row className='justify-content-end mt-5'>
        <div className='col-3'>
          <div className="d-flex justify-content-end">
            <button className="btn btn-castleGray me-2 px-4 flex-grow-1" disabled={apiCallInProcess} onClick={()=> onCancel()}>
              Cancel
            </button>
            <button className="btn btn-castleRed px-4 flex-grow-1" disabled={apiCallInProcess} onClick={()=> handleSaveOnClick()}>
              Save
            </button>
          </div>
        </div>
      </Row>
    </Container>
  </>);
};

DuplicateClass.propTypes={
  onCancel: PropTypes.func.isRequired,
  handleSave: PropTypes.func,
};
export default DuplicateClass;